export enum ContentLandingPageFileType {
  CSV = 'csv',
  PDF = 'pdf',
  IMAGE = 'image',
  HTML = 'html',
}
